/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_RankingsInputs */



/**
* | output |
* | --- |
* | "Rankings" |
*
* @param {Nav_RankingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nav_rankings = /** @type {((inputs?: Nav_RankingsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_RankingsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Classements")
	if (locale === "es") return /** @type {LocalizedString} */ ("Clasificaciones")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Classificações")
	if (locale === "it") return /** @type {LocalizedString} */ ("Classifiche")
	return /** @type {LocalizedString} */ ("Rankings")
});